import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { observable } from 'mobx';
import { ActionType } from 'types/shared';

export class OpinionLabStore extends Store {
  @observable public label: string;
  @observable public selectAction: ActionType;

  public hydrate(data: SerializedData): void {
    if (data) {
      Object.assign(this, data);
    }
  }
}

OpinionLabStore.DEFAULTS = {};
